module.exports = __webpack_public_path__ + "img/j2.711fc9ee.png";